"use client";

import { Link } from "react-router-dom";
import { useState } from "react";
import { Button } from "@vionixasia/shared-components";
import { ConfirmationModal } from "./ConfirmationModal";
import { WhatsAppStatusBadge } from "./WhatsAppStatusBadge";
import type { RaceResult } from "@/types/result";

export function ResultTable({
  results,
  onSend,
}: {
  results: RaceResult[];
  onSend: (ids: string[]) => Promise<void>;
}) {
  const [selected, setSelected] = useState<string[]>([]);
  const [confirmIds, setConfirmIds] = useState<string[]>([]);

  const allVisibleIds = results.map((result) => result.id);
  const selectedRows = results.filter((result) => selected.includes(result.id));

  function toggleAll() {
    setSelected(selected.length === allVisibleIds.length ? [] : allVisibleIds);
  }

  async function confirmSend() {
    await onSend(confirmIds);
    setConfirmIds([]);
    setSelected([]);
  }

  return (
    <>
      <div className="mb-3 flex flex-wrap gap-2">
        <Button color="teal" disabled={selectedRows.length === 0} onClick={() => setConfirmIds(selected)}>
          Send WhatsApp Selected
        </Button>
        <Button variant="muted" onClick={() => setConfirmIds(results.filter((result) => result.whatsapp_status !== "skipped").map((result) => result.id))}>
          Send All Valid
        </Button>
        <Button variant="muted" onClick={() => setConfirmIds(results.filter((result) => result.whatsapp_status === "failed").map((result) => result.id))}>
          Retry Failed
        </Button>
      </div>
      <div className="table-scroll rounded-card border border-line bg-white">
        <table className="min-w-full text-left text-sm">
          <thead className="bg-surface text-muted">
            <tr>
              <th className="px-3 py-2"><input type="checkbox" checked={selected.length === allVisibleIds.length && allVisibleIds.length > 0} onChange={toggleAll} /></th>
              {["BIB", "Runner Name", "Phone", "Category", "Finish Time", "Rank", "WhatsApp Status", "Last Sent At", "Action"].map((label) => (
                <th key={label} className="px-3 py-2 font-medium">{label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {results.map((result) => (
              <tr key={result.id} className="border-t border-line">
                <td className="px-3 py-2"><input type="checkbox" checked={selected.includes(result.id)} onChange={() => setSelected((prev) => prev.includes(result.id) ? prev.filter((id) => id !== result.id) : [...prev, result.id])} /></td>
                <td className="px-3 py-2">{result.bib_number || "-"}</td>
                <td className="px-3 py-2 font-medium text-ink">{result.runner_name}</td>
                <td className="px-3 py-2">{result.phone_number}</td>
                <td className="px-3 py-2">{result.category || "-"}</td>
                <td className="px-3 py-2">{result.finish_time}</td>
                <td className="px-3 py-2">{result.rank || "-"}</td>
                <td className="px-3 py-2"><WhatsAppStatusBadge status={result.whatsapp_status} /></td>
                <td className="px-3 py-2">{result.whatsapp_sent_at ? "sent" : "-"}</td>
                <td className="px-3 py-2">
                  <div className="flex gap-2">
                    <Link className="text-brand" to={result.result_url} target="_blank">View</Link>
                    <Button variant="ghost" color="teal" className="px-2 py-1" onClick={() => setConfirmIds([result.id])}>{result.whatsapp_status === "failed" ? "Retry" : "Send"}</Button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <ConfirmationModal open={confirmIds.length > 0} title="Send WhatsApp Result" confirmLabel="Send WhatsApp" onCancel={() => setConfirmIds([])} onConfirm={confirmSend}>
        Anda akan mengirim WhatsApp ke {confirmIds.length} peserta. Pesan ini menggunakan template: finish_result. Lanjutkan?
      </ConfirmationModal>
    </>
  );
}
